import { render, staticRenderFns } from "./UnitSection.vue?vue&type=template&id=b2e459e0&scoped=true"
import script from "./UnitSection.vue?vue&type=script&lang=js"
export * from "./UnitSection.vue?vue&type=script&lang=js"
import style0 from "./UnitSection.vue?vue&type=style&index=0&id=b2e459e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e459e0",
  null
  
)

export default component.exports